/**
 * Label maps for dispute enums. Kept out of dispute-status-chip.tsx so that
 * file only exports components (react-refresh).
 */
export const DISPUTE_REASON_LABEL: Record<string, string> = {
  WRONG_ITEM: "Wrong Item",
  DAMAGED_IN_TRANSIT: "Damaged in Transit",
  NOT_DELIVERED: "Not Delivered",
  PARTIAL_DELIVERY: "Partial Delivery",
  LATE_DELIVERY: "Late Delivery",
  BILLING_ISSUE: "Billing Issue",
  OTHER: "Other",
};
